export const English = {
  Footer: {
    copyRight: "© Copyrights Clinion 2023. All rights reserved.",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    designed: "Designed and develpoed by Clinion",
  },
  error: {
    BloodSugarRecord: {
      Blood_sugar_value: {
        empty: "Blood sugar value is required.",
        base: "Blood sugar value must be a number.",
      },
      time_Dropdown_Value: { required: "Please select Time Value" },
      Meal_Code_Dropdown: { required: "Please select meal code." },
      MealTime: "Please select a valid Meal time",
    },
    Hypoglycemia: {
      bloodSugarValue: {
        empty: "Blood sugar value is required.",
        base: "Blood sugar value must be a number.",
      },
      symptoms: {
        required: "At least one symptom must be selected.",
        base: "At least one symptom must be selected.",
      },
      reactionRecognizedBy: {
        required: "Reaction recognized by is required.",
      },
      treatment: {
        required: "At least one treatment must be selected.",
        min: "At least one treatment must be selected.",
      },
      time: {
        time: "Please select Time",
        validTime: "Please select a valid time",
      },
      date: {
        date: "Please select Date",
        validDate: "Please select a valid Date",
      },
      other: {
        other: "Other value is required",
      },
      symptoms: {
        symptoms: "Atleast one Symptom must be selected",
      },
      treatment: {
        treatment: "At least one Treatment must be selected",
      },
    },
  },
  Message: {
    unableInsert: "Unable to insert page data",
    noDataChanged: "No data changed",
  },
  LoginTitle: {
    language_title: "Please Select Your Language Preference",
    enterNumb_title: "Please Enter Your Mobile Number and Verify",
    selectLang_label: "Choose your preferred language",
    enterNumb_label: "Please Enter Your Mobile Number ",
    enterOTP_label: "Enter CODE",
    sendOPT_btnText: "SEND OTP",
    verifyOTP_btnText: "VERIFY CODE",
    proceed_btnText: "PROCEED",
    varifyNum_title: "Enter Your E-Pro Code",
    backImage_title:
      "Decentralise Your Trials With Clinion eCOA For Enhanced Real-World Data",
    mobileNo: "MobileNo",
  },

  NavbarTitle: {
    patient_num: "Subject ID",
    protocol_num: "Protocol ID",
  },

  Patient: {
    studyTitle: "Study Title",
    patient_Head: "Subject Details",
    siteId: "Site Name ID",
    investigator_Name: "Investigator Name",
    siteAdd: "Site Address and Contact",
    screeningDate: "Screening Date",
    screening_Number: "Screening Number",
  },

  InstructionTitle: {
    instruction_head: "GENERAL INSTRUCTIONS",
  },

  visitsTitle: {
    visits_head: "Visits",
    legend: "Legend",
  },

  Language_Menu: [
    {
      id: 1,
      name: "English",
    },
    {
      id: 2,
      name: "Spanish",
    },
  ],

  Form_Sidebar: {
    visitnum: "VISIT 1-SCREENING/BASELINE",
    daynum: "Day-",
    date: "22/May/2023",
    formText1: "Hypoglycemia",
    bloodSugar1: "Blood-sugar Record 1",
    bloodSugar2: "Blood-sugar Record 2",
    bloodSugar3: "Blood-sugar Record 3",
    bloodSugar4: "Blood-sugar Record 4",
    bloodSugar5: "Blood-sugar Record 5",
    bloodSugar6: "Blood-sugar Record 6",
    bloodSugar7: "Blood-sugar Record 7",
    legend: "Legend",
  },

  visitPageandStatus: {
    startDate: "StartDate",
    endDate: "EndDate",
    title: "Pages and Status",
    visitnum: "VISIT 1-SCREENING/BASELINE",
    treatmentDetails: "H1 Antihistamine treatement details",
    weeklyActivity: "Weekly urticaria activity",
    generalForm: "General Forms",
    notStarted: "Not Started",
    active: "Active",
    inProgress: "In-Progress",
    Completed: "Completed",
    selectDate: "Select Date:",
    emptyDataText:
      " This is the place Where you will find all your saved records. Click the ADD NEW button to add <br></br> records and they'll showup here",
    savedRecords: "Saved Records",
    record_Date: "Record Date",
    status: "Status",
  },

  HypoglycemiaTitles: {
    Record_Number: "Record Number",
    Date: "Date",
    Time: "Time",
    Blood_sugar_value: "Blood Sugar Value",
    Symptoms: "Symptoms felt or what did you notice?",
    Recognize: "The reaction was recognized by",
    Treatment: "Treatment for the reaction needed",
    sym: "SYMPTOMS",
    treatment: "	TREATMENT",
    reaction: "	REACTIONS",
    symOther: "SYMPTOMS(OTHER)",
    Symptoms_Options: [
      { text: "sweating", value: "1", english: "sweating" },
      { text: "shaking", value: "2", english: "shaking" },
      { text: "heart palpitations", value: "3", english: "heart palpitations" },
      {
        text: "problems with vision",
        value: "4",
        english: "problems with vision",
      },
      { text: "change in behavior", value: "5", english: "change in behavior" },
      { text: "confusion", value: "6", english: "confusion" },
      { text: "fainting", value: "7", english: "fainting" },
      { text: "other", value: "8", english: "other" },
    ],
    Reaction_Recognized_By_Options: [
      { text: "Yourself", value: "1", english: "Yourself" },
      {
        text: "Routine test on your meter",
        value: "2",
        english: "Routine test on your meter",
      },
      { text: "Someone else", value: "3", english: "Someone else" },
    ],
    Treatment_options: [
      {
        text: "Juice/Food/Glucose tablets",
        value: "1",
        english: "Juice/Food/Glucose tablets",
      },
      {
        text: "Help from someone else",
        value: "2",
        english: "Help from someone else",
      },
      {
        text: "Injection of Glucagon",
        value: "3",
        english: "Injection of Glucagon",
      },
      { text: "Hospital/Ambulance", value: "4", english: "Hospital/Ambulance" },
    ],
  },
  BloodSugarRecords: {
    action: "Actions",
    weeklyActivity: "Weekly blood sugar activity score documentation",
    visitnum: "VISIT-1 (Day-14) (Week-2)",
    newRecord: "ADD NEW RECORD",
    Time: "Time",
    Meal_Time: "Meal Time",
    Meal_Code: "Meal Code",
    Blood_sugar_value: "Blood Sugar",
    Bolus_Insulin: "Bolus Insulin",
    Insulin_Type: "Insulin Type",
    Insulin_Type_2: "Insulin Type",
    Basal_Insulin: "Basal Insulin",
    Pump_Insulin_Units: "Pump Insulin Units",
    Pump_Insulin_Type: "Pump Insulin Type",
    Total_Bolus: "Total Bolus",
    Total_Basal: "Total Basal",
    Total_Pump: "Total Pump",
    insulin: "INSULIN",
    dropdown: [
      {
        id: "1",
        name: "Dropdown1",
      },
      {
        id: "2",
        name: "Dropdown2",
      },
      {
        id: "3",
        name: "Dropdown3",
      },
    ],
    Time_Dropdown: [
      {
        id: "1",
        name: "12:00 AM",
      },
      {
        id: "2",
        name: "1:00 AM",
      },
      {
        id: "3",
        name: "2:00 AM",
      },
      {
        id: "4",
        name: "3:00 AM",
      },
      {
        id: "5",
        name: "4:00 AM",
      },
      {
        id: "6",
        name: "5:00 AM",
      },
      {
        id: "7",
        name: "6:00 AM",
      },
      {
        id: "8",
        name: "7:00 AM",
      },
      {
        id: "9",
        name: "8:00 AM",
      },
      {
        id: "10",
        name: "9:00 AM",
      },
      {
        id: "11",
        name: "10:00 AM",
      },
      {
        id: "12",
        name: "11:00 AM",
      },
      {
        id: "13",
        name: "12:00 PM",
      },
      {
        id: "14",
        name: "1:00 PM",
      },
      {
        id: "15",
        name: "2:00 PM",
      },
      {
        id: "16",
        name: "3:00 PM",
      },
      {
        id: "17",
        name: "4:00 PM",
      },
      {
        id: "18",
        name: "5:00 PM",
      },
      {
        id: "19",
        name: "6:00 PM",
      },
      {
        id: "20",
        name: "7:00 PM",
      },
      {
        id: "21",
        name: "8:00 PM",
      },
      {
        id: "22",
        name: "9:00 PM",
      },
      {
        id: "23",
        name: "10:00 PM",
      },
      {
        id: "24",
        name: "11:00 PM",
      },
    ],
    Meal_Code_Dropdown: [
      {
        id: "1",
        name: "Pre Meal",
        english: "Pre Meal",
      },
      {
        id: "2",
        name: "2 hours post meal",
        english: "2 hours post meal",
      },
      {
        id: "3",
        name: "Bedtime",
        english: "Bedtime",
      },
    ],
    Pump_Insulin_Type_Dropdown: [
      {
        id: "1",
        name: "Humalog",
        english: "Humalog",
      },
      {
        id: "2",
        name: "Novolog",
        english: "Novolog",
      },
      {
        id: "3",
        name: "FiAsp",
        english: "FiAsp",
      },
      {
        id: "4",
        name: "Other",
        english: "Other",
      },
    ],
    Insulin_Type_Dropdown: [
      {
        id: "1",
        name: "Lantus",
        english: "Lantus",
      },
      {
        id: "2",
        name: "Levemir",
        english: "Levemir",
      },
      {
        id: "3",
        name: "Tresiba",
        english: "Tresiba",
      },
      {
        id: "4",
        name: "NPH",
        english: "NPH",
      },
      {
        id: "5",
        name: "Regular",
        english: "Regular",
      },
      {
        id: "6",
        name: "Humalog",
        english: "Humalog",
      },
      {
        id: "7",
        name: "Novolog",
        english: "Novolog",
      },
      {
        id: "8",
        name: "Apidra",
        english: "Apidra",
      },
      {
        id: "9",
        name: "FiAsp",
        english: "FiAsp",
      },
      {
        id: "10",
        name: "Other",
        english: "Other",
      },
    ],
  },

  selectedLabel: {
    dropdownLabel: "select",
  },
  ButtonText: {
    Add_New_Entry: "Add New",
    Save: "Save",
    Submit: "Submit",
    Cancel: "Cancel",
    Previous: "Previous",
    Next: "Next",
    backtosaved: "BACK TO SAVED RECORDS",
    backtoVisit: "BACK TO VISITS",
  },
  AlertMsg: {
    selectdRecordDate: "Please Select the Date",
    selectVisitDate: "No Active Visit is Found For The Selected Date",
    navigateToHypoglycemia:
      "Blood sugar level is less than 54.Please complete the Hypoglecemia form",
    maxLimitToEnterForm: "You Can Enter Maxium 10 Records per day",
    logout: "Do You want to logout?",
  },
};
